import { apiCall } from "../utility/apiCall";

export const subscripePlan = async (payload) => {
  return await apiCall("api/subscripePlan", "POST", payload);
};

export const getRateCards = async function () {
  // console.log("getRateCards start");
  return await apiCall("api/ratecard", "GET");
  //console.log('getRateCards : ' + JSON.stringify(ratecards));
  // const ratecardList = [];
  // for (let plangroupindex = 0; plangroupindex < ratecards.length; plangroupindex++) {
  //     const planGroup = ratecards[plangroupindex];
  //     if (!planGroup.IsPersist) {
  //         for (let ratecardindex = 0; ratecardindex < planGroup.plans.length; ratecardindex++) {
  //             const ratecard = planGroup.plans[ratecardindex];
  //             ratecardList.push({ PlanGroupID: planGroup.PlanGroupID, planGroup: planGroup.planGroup, PlanID: ratecard.PlanID, PlanName: ratecard.PlanName, Price: ratecard.Price, Size: ratecard.Size, DiscountedPrice: ratecard.DiscountedPrice, Price: ratecard.Price })
  //         }
  //     }
  // }
  // console.log('getRateCards : ' + JSON.stringify(ratecardList));
  //return ratecardList;
};

export const checkOutPayment = async (payload) => {
  // console.log('checkOutPayment - service call:' + JSON.stringify(payload));
  return await apiCall("api/invoice", "POST", payload);
};

export const paymentWebhook = async (payload) => {
  // console.log('paymentWebhook - service call:' + JSON.stringify(payload));
  return await apiCall("api/paymentWebhook", "POST", payload);
};

export const getUserCurrentPlan = async (payload) => {
  // console.log('getUserCurrentPlan - service call:' + JSON.stringify(payload));
  return await apiCall("api/userCurrentPlan", "POST", payload);
};



// WEBPACK FOOTER //
// ./src/services/pricing.js